import { Component, EventEmitter, Input, Output, input } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  imports: [SharedModule, ButtonComponent],
})
export class ConfirmationModalComponent {
  @Input() caption = '';
  @Input() message = '';
  @Input() data!: any;
  @Input() primaryButtonText = '';
  @Input() secondaryButtonText = '';
  @Input() primaryButtonLoading = false;
  @Input() secondaryButtonLoading = false;
  @Output() onPrimaryButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onSecondaryButtonClick: EventEmitter<any> = new EventEmitter();

  emitPrimaryButtonClick() {
    this.onPrimaryButtonClick.emit(this.data);
  }
  emitSecondaryButtonClick() {
    this.onSecondaryButtonClick.emit(this.data);
  }
}
